import React from "react";
import {
  Box,
  Button,
  Checkbox,
  Divider,
  IconButton,
  InputBase,
  List,
  ListItemButton,
  ListItemText,
  Paper,
  Popover,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SearchIcon from "@mui/icons-material/Search";
import labelService from "../services/labelService";
import { CreateLabelDialog } from "./CreateLabelDialog";
import task from "../services/task";


function findLabelsWithEmail(labels, emailID, parentPath = "") {
  let result = [];

  for (const label of labels) {
    const currentPath = parentPath ? `${parentPath}/${label.name}` : label.name;


    if (Array.isArray(label.emailId) && label.emailId.includes(emailID)) {
      result.push(currentPath);
    }


    if (label.children && label.children.length > 0) {
      result = result.concat(findLabelsWithEmail(label.children, emailID, currentPath));
    }
  }

  return result;
}

export function LabelList({ anchorEl, setAnchorEl, selectedEmailID, TaskId,isAdd=false,isSend,labelname,setLabelname }) {


  const open = Boolean(anchorEl);
  const [query, setQuery] = React.useState("");
  const [selected, setSelected] = React.useState([]);
  const [labels, setLabels] = React.useState([]);
  const [labelObjects, setLabelObjects] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [applying, setApplying] = React.useState(false);
  const [createDialogOpen, setCreateDialogOpen] = React.useState(false);

  React.useEffect(() => {
    if (open) fetchLabels();
  }, [open]);
  React.useEffect(() => {
    if ( selected.length >= 0 && labelname) {
      setLabelname(selected)
    }
  }, [selected]);
  const flattenLabels = (labels, parentPath = "") => {
    let result = [];
    for (const label of labels) {
      const path = parentPath ? `${parentPath}/${label.name}` : label.name;
      result.push(path);
      if (label.children && label.children.length > 0) {
        result = result.concat(flattenLabels(label.children, path));
      }
    }
    return result;
  };

  async function fetchLabels() {
    setLoading(true);
    try {
      const res = await labelService.GET_Label_ALL();
      const fetchedLabels = res.data?.labels || [];
      setLabelObjects(fetchedLabels);


      const flattened = flattenLabels(fetchedLabels);
      setLabels(flattened);


      const preSelected = findLabelsWithEmail(fetchedLabels, selectedEmailID);
      setSelected(preSelected);
    } catch (error) {
      console.error("Error fetching labels:", error);
    } finally {
      setLoading(false);
    }
  }




  const handleClose = () => setAnchorEl(null);

  const toggle = (label) => {
    setSelected((prev) =>
      prev.includes(label) ? prev.filter((v) => v !== label) : [...prev, label]
    );
  };

  const filtered = React.useMemo(() => {
    const q = query.trim().toLowerCase();
    if (!q) return labels;
    return labels.filter((l) => l.toLowerCase().includes(q));
  }, [labels, query]);

  function findLabelByPath(labels, path, parentPath = "") {
    for (const label of labels) {
      const currentPath = parentPath
        ? `${parentPath}/${label.name}`
        : label.name;
      if (currentPath === path) return label;
      if (label.children) {
        const found = findLabelByPath(label.children, path, currentPath);
        if (found) return found;
      }
    }
    return null;
  }
  async function handleApply() {
    if (selected.length === 0) return;
    setApplying(true);

    try {

      for (const labelPath of selected) {
        const labelObj = findLabelByPath(labelObjects, labelPath);
        if (!labelObj) continue;

        const res = await labelService.GET_Label_By_Id(labelObj.id);
        const fullLabel = res.data.data;
        if (!fullLabel) continue;

        const updatedEmailIds = Array.isArray(fullLabel.emailId)
          ? [...fullLabel.emailId, selectedEmailID]
          : [selectedEmailID];

        const payload = {
          name: labelPath.split("/").pop(),
          color: "#FF0000",
          emailId: [...new Set(updatedEmailIds)],
        };

        await labelService.Update_Label_By_Id(labelObj.id, payload);
      }

      if (TaskId) {
        try {
          const data = await task.UPDATE_TASK(TaskId, { isLabel: true });

        } catch (err) {
          console.error("Error updating task:", err);
        }
      }

      setSelected([]);
      handleClose();
    } catch (error) {
      console.error("Error applying labels:", error);
    } finally {
      setApplying(false);
    }
  }




  return (
    <>

      <Box style={{ backgroundColor: "red" }}>
        <CreateLabelDialog
          open={createDialogOpen}
          setOpen={setCreateDialogOpen}
          fetchAllLabels={fetchLabels}
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        />

        <Popover
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "center",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "center",
            horizontal: "left",
          }}
          slotProps={{
            paper: {
              elevation: 3,
              sx: {
                ml: 1,
              },
            },
          }}
        >
          <Paper
            sx={{
              width: 320,
              borderRadius: 2,
              overflow: "hidden",
              position: "relative",

            }}
          >
            <IconButton
              size="small"
              onClick={handleClose}
              sx={{
                position: "absolute",
                top: 6,
                right: 6,
                color: "text.secondary",
                "&:hover": { color: "error.main" },
              }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>

            <Box sx={{ px: 2, pt: 2 }}>
              <Typography variant="body2" color="text.secondary">
                Label as:
              </Typography>

              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  mt: 1,
                  pb: 0.5,
                  borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
                }}
              >
                <InputBase
                  fullWidth
                  value={query}
                  onChange={(e) => setQuery(e.target.value)}
                  placeholder="Search labels"
                  inputProps={{ "aria-label": "Search labels" }}
                  sx={{ py: 0.5 }}
                />
                <IconButton size="small" aria-label="Search">
                  <SearchIcon fontSize="small" />
                </IconButton>
              </Box>
            </Box>

            <List
              dense
              disablePadding
              sx={{ maxHeight: 260, overflow: "auto", px: 1 }}
            >
              {loading ? (
                <Typography sx={{ p: 2, textAlign: "center" }}>
                  Loading...
                </Typography>
              ) : filtered.length > 0 ? (
                filtered.map((labelPath) => (
                  <ListItemButton
                    key={labelPath}
                    onClick={() => toggle(labelPath)}
                    dense
                    sx={{ py: 0.5 }}
                  >
                    <Checkbox
                      edge="start"
                      tabIndex={-1}
                      disableRipple
                      checked={selected.includes(labelPath)}
                      inputProps={{ "aria-label": `Toggle ${labelPath}` }}
                    />
                    <ListItemText
                      primary={labelPath}
                      primaryTypographyProps={{
                        noWrap: true,
                        sx: { fontSize: "0.875rem" },
                      }}
                    />
                  </ListItemButton>
                ))
              ) : (
                <Typography sx={{ p: 2, textAlign: "center" }}>
                  No labels found
                </Typography>
              )}
            </List>

            <Divider />

            <Box
              sx={{ display: "flex", justifyContent: "space-between", p: 1.5 }}
            >
              <Button
                size="small"
                variant="text"
                onClick={() => setCreateDialogOpen(true)}
              >
                + Create new
              </Button>

              {!isAdd && selected.length > 0 && (
                <Button
                  size="small"
                  variant="contained"
                  color="primary"
                  onClick={handleApply}
                  disabled={applying}
                >
                  {applying ? "Applying..." : "Apply"}
                </Button>
              )}
            </Box>
          </Paper>
        </Popover>
      </Box>
    </>
  );
}
